//App entry point, all libraries come here
import "bootstrap/dist/css/bootstrap.css"
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
/*

*/
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: "AIzaSyB3ZS11PUVihUlwJShMhCr0iVaF7jnp-Ug",
    authDomain: "tuber-trader.firebaseapp.com",
    projectId: "tuber-trader",
    storageBucket: "tuber-trader.appspot.com",
    messagingSenderId: "473765063343",
    appId: "1:473765063343:web:5c5e85b329ce501e07025a",
    measurementId: "G-2C348W1XJJ"
  };

const vueApp = createApp(App)

vueApp.config.globalProperties.$app = initializeApp(firebaseConfig);
vueApp.config.globalProperties.$loggedIn = false;
vueApp.config.globalProperties.$test = true;
vueApp.config.globalProperties.$user = null;

vueApp.use(router).mount('#app')



import "bootstrap/dist/js/bootstrap.js";


